(function () {
    'use strict';

    angular
        .module('pdgWp')
        .config(cpOrphansConfig);

    /** @ngInject */
    function cpOrphansConfig($stateProvider) {

        var cpOrphans = {
            name : 'cp-orphans',
            url  : '/cp-orphans',
            resolve: {
                itemsList  : function (itemsSrv) {

                    var configObj = {
                        search   : true,
                        expandGid: true,
                        prices   : true,
                        gpModOdr : 'DESC',
                        getPaging: true,
                        limit    : "10",
                        page     : "1"

                    };

                    return itemsSrv.getItems(configObj)
                                   .then(function (itemsList) {
                                       return itemsList.data;
                                   });
                },
                itemDetails: function () {
                    return {};
                }
            },
            views: {
                'sideNavRight@': {
                    templateUrl : '/ng-app/admin-app/website-admin/items/items-list.partial.html',
                    controller  : 'ItemsListController',
                    controllerAs: 'itemsListCtrl'
                },
                'main@': {
                    templateUrl : '/ng-app/admin-app/website-admin/cp-orphans/cp-orphans.partial.html',
                    controller  : 'CpOrphansController',
                    controllerAs: 'cpOrphansCtrl'
                }
            }
        };

        $stateProvider.state(cpOrphans);
    }
})();
